/**
 * Admin schemas for `/admin/ai-provider-credentials` — 2026-07-27 (user
 * request), multi-provider AI. The operator types each provider's API key
 * directly into the admin UI; it's stored encrypted in
 * `ai_provider_credentials` (see `services/secrets/provider-key-crypto.ts`).
 *
 * **The plaintext key is NEVER returned by any response schema below** —
 * every read-side shape carries only a `configured: boolean` per provider.
 */
import { Type } from '@sinclair/typebox';
import { AdminError } from './users.js';
export const AI_PROVIDERS = ['openai', 'gemini', 'claude'];
export const AiProviderParam = Type.Object({
    provider: Type.Union(AI_PROVIDERS.map((p) => Type.Literal(p))),
});
export const AiProviderCredentialsStatus = Type.Object({
    openai: Type.Boolean(),
    gemini: Type.Boolean(),
    claude: Type.Boolean(),
});
export const AiProviderCredentialsStatusResponse = Type.Object({
    providers: AiProviderCredentialsStatus,
});
export const AiProviderCredentialSet = Type.Object({
    apiKey: Type.String({ minLength: 1, maxLength: 2000 }),
});
export const AiProviderCredentialResponse = Type.Object({
    provider: Type.Union(AI_PROVIDERS.map((p) => Type.Literal(p))),
    configured: Type.Boolean(),
});
export { AdminError };
//# sourceMappingURL=ai-provider-credentials.js.map